import React, {Fragment} from 'react'
import {Switch, Route, Redirect} from "react-router-dom";
import Home from "../components/main/Home";
import Header from "../components/ui/Header";
import AddProduct from "../components/main/AddProduct";
import Categorie from "../components/main/Categorie";
import GameScreen from "../components/main/GameScreen";
import Search from "../components/main/Search";

const RouteSecond = () => {
    return (
        <Fragment>
            <Header />
            <Switch>
                <Route exact path = "/home" component = {Home} />
                <Route exact path = "/add" component = {AddProduct} />
                <Route exact path = "/categories/:categorie" component = {Categorie} />
                <Route exact path = "/:categorie/:consoleGaming/:id" component ={GameScreen} />
                <Route exact path = "/search" component = {Search} />

                <Redirect to = "/login" />
            </Switch>
        </Fragment>
    );
}
 
export default RouteSecond;